import { IClassroomResource } from "../../classrooms/types";
import { serialize } from "../../utils";
import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBriefAssignmentList } from "../types";
export interface IBriefAssignmentListQueryParameters extends IPaginateable {
    filters: {
        classroom?: RelationalValue<IClassroomResource>;
    };
}

function mapFilters(filters: IBriefAssignmentListQueryParameters["filters"]) {
    const { classroom } = filters;

    return {
        "classroom.uuid": mapRelationalValue(classroom),
    };
}

export type IBriefAssignmentListQueryResult = IBriefAssignmentList;

export const briefAssignmentListQuery: IApiQueryFunction<IBriefAssignmentListQueryParameters> = ({
    filters,
    pagination,
}) => {
    const { classroom } = filters;

    if (!classroom) {
        return;
    }

    return {
        method: "GET",
        url: `/brief-assignments${serialize({ ...mapPagination(pagination), ...mapFilters(filters) }, true)}`,
        data: {
            "classroom.uuid": mapRelationalValue(classroom),
        },
    };
};

export const useBriefAssignmentListQuery = createApiQueryHook<
    IBriefAssignmentListQueryParameters,
    IBriefAssignmentListQueryResult
>(briefAssignmentListQuery);
